import type { SectionLocale } from '../types'

export const NEWS_LOCALE: SectionLocale = [
  [
    'news_delete_question',
    {
      ru: 'Вы уверены, что хотите удалить новость?',
      en: 'Are you sure you want to delete this news?',
    },
  ],
  [
    'news_search_not_found',
    {
      ru: 'Новость не найдена',
      en: 'News not found',
    },
  ],
  [
    'news_list_error',
    {
      ru: 'Не удалось загрузить список новостей. Попробуйте обновить страницу.',
      en: 'Failed to load the news list. Please refresh the page.',
    },
  ],
  [
    'news_item_not_found',
    {
      ru: 'Новость не найдена',
      en: 'News item not found',
    },
  ],
  [
    'news_add_item',
    {
      ru: 'Добавить новость',
      en: 'Add news',
    },
  ],
  [
    'news_search_placeholder',
    {
      ru: 'Поиск новости',
      en: 'Search news',
    },
  ],
  [
    'news_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'news_edit_item',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'news_delete_item',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'news_edit_title',
    {
      ru: 'Заголовок новости',
      en: 'News title',
    },
  ],
  [
    'news_breadcrumb_add',
    {
      ru: 'Добавление',
      en: 'Add',
    },
  ],
  [
    'news_breadcrumb_edit',
    {
      ru: 'Редактирование',
      en: 'Edit',
    },
  ],
  [
    'news_cover_label',
    {
      ru: 'Обложка новости',
      en: 'News cover',
    },
  ],
  [
    'news_cover_drag_hint',
    {
      ru: 'Для загрузки перетащите файл или нажмите сюда',
      en: 'Drag a file here or click to upload',
    },
  ],
  [
    'news_cover_hint',
    {
      ru: 'Размер файла не более 10MB. Минимальный размер 1500х500 px',
      en: 'Max file size 10MB. Minimum size 1500×500 px',
    },
  ],
  [
    'news_create_page_title',
    {
      ru: 'Добавление новости',
      en: 'Add news',
    },
  ],
  [
    'news_edit_page_title',
    {
      ru: 'Редактирование новости',
      en: 'Edit news',
    },
  ],
  [
    'news_remove_cover',
    {
      ru: 'Удалить обложку',
      en: 'Remove cover',
    },
  ],
  [
    'news_cover_size_error',
    {
      ru: 'Размер файла не должен превышать 10MB',
      en: 'File size must not exceed 10MB',
    },
  ],
  [
    'news_editor_toolbar',
    {
      ru: 'Панель форматирования текста',
      en: 'Text formatting toolbar',
    },
  ],
  [
    'news_editor_content_required',
    {
      ru: 'Введите текст новости',
      en: 'Enter the news text',
    },
  ],
  [
    'news_editor_content_too_short',
    {
      ru: 'Текст новости должен содержать не менее {min} символов',
      en: 'News text must be at least {min} characters',
    },
  ],
  [
    'news_editor_content_too_long',
    {
      ru: 'Текст новости не должен превышать {max} символов',
      en: 'News text must not exceed {max} characters',
    },
  ],
]
